<template>
  <div>
    <div class="flex justify-between content-center">
      <heading class="self-center font-semibold" :level="1">{{ $t('User seats') }}</heading>
      <counter-field
        :value="value"
        :min-count="currentCount"
        @input="$emit('input', $event)"
      />
    </div>
    <p v-if="price" class="mb-6 mt-2 small text-right">
      {{
        $n(price, {
          key: 'currency',
          currencyCode: currency,
        })
      }}
      {{ $t(' / user / {interval}', { interval: formatInterval(interval) }) }}
    </p>
  </div>
</template>

<script>
  import CounterField from '@/_legacy/components/Form/CounterField.vue';

  export default {
    name: 'UserCountField',

    components: { CounterField },

    props: {
      value: {
        type: [String, Number],
        default: 1,
      },

      price: {
        type: [String, Number],
        default: null,
      },

      currency: {
        type: String,
        default: null,
      },

      interval: {
        type: String,
        default: null,
      },
      currentCount: {
        type: [String, Number],
        default: 1,
      },
    },

    methods: {
      formatInterval(interval) {
        return {
          day: this.$t('day'),
          month: this.$t('month'),
          year: this.$t('year'),
        }[interval] || interval;
      },
    },
  };
</script>
